import { createRoot } from 'react-dom/client'
import { MainAppRender } from '@reapitform/core'
import '@reapit/elements/dist/index.css'
import '@reapitform/common-ui/dist/style.css'
import '@reapitform/utils/dist/style.css'
import { queryClient } from '@reapitform/core'
import { StrictMode } from 'react'
import { MainRouter } from './core'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MainAppRender queryClient={queryClient}>
      <MainRouter />
    </MainAppRender>
  </StrictMode>,
)
